import React from 'react';
import { Box } from 'atoms';

function HeaderRow() {
	return (
		<Box width="100%" display="flex" justifyContent="center" mb={4}>
			<Box
				display="flex"
				alignItems="center"
				flexWrap="wrap"
				padding="16px 32px"
				gap="16px"
				width="100%"
				maxWidth="100%"
				background="#18405D"
				borderRadius="4px 4px 0 0"
				overflow="hidden"
			>
				<Box
					flex="0 0 6%"
					color="#FFFFFF"
					fontSize="clamp(12px, 1.2vw, 14px)"
					lineHeight="17px"
				>
					Trip ID
				</Box>

				<Box
					flex="0 0 12%"
					color="#FFFFFF"
					fontSize="clamp(12px, 1.2vw, 14px)"
					lineHeight="17px"
				>
					<Box display="flex" flexDirection="column">
						<span>Project</span>
						<span>location code</span>
					</Box>
				</Box>

				<Box
					flex="0 0 10%"
					color="#FFFFFF"
					fontSize="clamp(12px, 1.2vw, 14px)"
					lineHeight="21px"
				>
					Client Name
				</Box>

				<Box
					flex="0 0 11%"
					color="#FFFFFF"
					fontSize="clamp(12px, 1.2vw, 14px)"
					lineHeight="21px"
				>
					Vendors Name
				</Box>

				<Box
					flex="0 0 10%"
					color="#FFFFFF"
					fontSize="clamp(12px, 1.2vw, 14px)"
					lineHeight="21px"
				>
					Vehicle No.
				</Box>

				<Box
					flex="0 0 13%"
					color="#FFFFFF"
					fontSize="clamp(12px, 1.2vw, 14px)"
					lineHeight="21px"
				>
					Reporting Time
				</Box>

				<Box
					flex="0 0 10%"
					color="#FFFFFF"
					fontSize="clamp(12px, 1.2vw, 14px)"
					lineHeight="21px"
				>
					Start Time
				</Box>

				<Box
					flex="0 0 10%"
					color="#FFFFFF"
					fontSize="clamp(12px, 1.2vw, 14px)"
					lineHeight="21px"
				>
					Run Time
				</Box>

				<Box
					flex="0 0 6%"
					color="#FFFFFF"
					fontSize="clamp(12px, 1.2vw, 14px)"
					lineHeight="21px"
				>
					Source
				</Box>

				<Box
					flex="0 0 5%"
					color="#FFFFFF"
					fontSize="clamp(12px, 1.2vw, 14px)"
					lineHeight="21px"
				>
					Valid
				</Box>

				<Box
					flex="0 0 7%"
					color="#FFFFFF"
					fontSize="clamp(12px, 1.2vw, 14px)"
					lineHeight="21px"
				>
					Action
				</Box>
			</Box>
		</Box>
	);
}

export default HeaderRow;
